import React, { useMemo } from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { toQR } from 'toqr';
import { QR_QUIET_ZONE, qrPath } from '../util/qrPath';

/**
 * QR-код ссылки-приглашения (аудит удобства 2026-10-04, вариант A + приглашение из C).
 *
 * <p>Кодирует `toqr` — крошечный кодировщик на чистом JS без нативной части (его и так тянет
 * Expo CLI), а рисует `react-native-svg`, который уже стоит в приложении: одна и та же
 * разметка работает на телефоне и в вебе, и ни нового нативного модуля, ни сборки ради него.
 *
 * <p>Всегда чёрное на белом, независимо от темы: светлый код на тёмном фоне многие камеры не
 * читают.
 */
export function InviteQrCode({
  value,
  size,
  accessibilityLabel,
}: {
  value: string;
  size: number;
  accessibilityLabel: string;
}) {
  const { size: modules, d } = useMemo(() => qrPath(toQR(value)), [value]);
  const box = modules + QR_QUIET_ZONE * 2;
  return (
    <Svg
      width={size}
      height={size}
      viewBox={`0 0 ${box} ${box}`}
      accessible
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="image">
      <Rect x={0} y={0} width={box} height={box} fill="#ffffff" />
      <Path d={d} fill="#000000" />
    </Svg>
  );
}
